import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { font, fontFamily } from 'assets/themes/theme-default'

import { Button } from '../../index'

const StyledButton = styled(Button)`
  &&& {
    color: ${props => props.theme.colors.color1.bg};
    font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.normal.name},`}
      ${fontFamily.normal};
    padding: 0;
    line-height: normal;
    span {
      font-size: ${font.size.base};
      text-decoration: underline;
      white-space: normal;
      line-height: normal;
    }
    :disabled {
      opacity: 0.5;
    }
  }
`

const Link = props => {
  const { children } = props

  return (
    <StyledButton {...props} type="link" data-test="component-link-button">
      {children}
    </StyledButton>
  )
}

Link.propTypes = {
  children: PropTypes.any
}

export default Link
